import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import HexColorDialog from './Dialogs/HexColorDialog';
import ProductMatchDialog from './Dialogs/ProductMatchDialog';
import {CompareResultModal} from './Dialogs/CompareResultModal';

const leftColStyle = {
  background: 'linear-gradient(135deg, #7C5869 0%, #FCB5B5 90%)'
};
const rightColStyle = {
  background: 'linear-gradient(135deg, #7D7ABC 0%, #FCB5B5 90%)'
};

const ColorMatchPage = () => {
  const [showHexDialog, setShowHexDialog] = useState(false);
  const [showProductDialog, setShowProductDialog] = useState(false);
  const [showCompareResult, setShowCompareResult] = useState(false);
  const [compareResult, setCompareResult] = useState(null);
  const navigate = useNavigate();

  const handleSaveHex = async (hex) => {
    try {
      const response = await fetch("https://makeupmatch.onrender.com/match-by-hex", {  
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ hex })
      });
      const data = await response.json();
      // Pass both color and API matches to the result page
      navigate('/colormatch/result', { state: { color: hex, matches: data.matches } });
    } catch (error) {
      console.error("API error:", error);
    }
  };
  const handleCompare = async (left, right) => {
  console.log("Comparing", left, right);
  if (!left?.shadeHex || !right?.shadeHex) {
    console.error("Missing shadeHex in compare products");
    return;
  }

  try {
    const response = await fetch("https://makeupmatch.onrender.com/compare-products", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ hex1: left.shadeHex, hex2: right.shadeHex })
    });

    if (!response.ok) {
      console.error("Compare API error:", response.status);
      return;
    }

    const result = await response.json();
    setCompareResult({ left, right, ...result });
    setShowCompareResult(true);
    setShowProductDialog(false);
  } catch (error) {
    console.error("Compare fetch exception:", error);
  }
};


  // Handle save from Product dialog
  const handleProductSubmit = (data) => {
    setShowProductDialog(false);
    if (!data) return;
    if (data.type === 'single') {
      navigate('/colormatch/product-match', { state: { ...data.product } });
    } else if (data.type === 'compare') {
      navigate('/colormatch/compare', { state: { left: data.left, right: data.right } });
    }
  };

  return (
    <Container fluid style={{ padding: 0 }}>
      <Row style={{ minHeight: '100vh' }}>
        <Col
          md={6}
          className="d-flex flex-column justify-content-center align-items-center"
          style={leftColStyle}
        >
          <h2>Match by Hex</h2>
          <p style={{ maxWidth: '80%', textAlign: 'center' }}>
            Enter a color hex code or pick with the wheel to find the closest makeup match.
          </p>
          <Button
            size="lg"
            className="mt-3"
            style={{backgroundColor: '#ffffffff', color:'#7C5869'}}
            onClick={() => setShowHexDialog(true)}
          >
            Match by Hex
          </Button>
        </Col>
        <Col
          md={6}
          className="d-flex flex-column justify-content-center align-items-center"
          style={rightColStyle}
        >
          <h2>Match by Product</h2>
          <p style={{ maxWidth: '80%', textAlign: 'center' }}>
            Select an existing product to instantly view suggested color matches from all brands or compare two!
          </p>
          <Button
            size="lg"
            className="mt-3"
            style={{backgroundColor: '#ffffffff', color:'#7D7ABC'}}
            onClick={() => setShowProductDialog(true)}
          > 
            Match by Product
          </Button>
        </Col>
      </Row>
      {/* Dialogs mounted outside Row/Col for cleaner overlay */}
      <HexColorDialog
        show={showHexDialog}
        onHide={() => setShowHexDialog(false)}
        onSave={handleSaveHex}
      />
      <ProductMatchDialog
        show={showProductDialog}
        onHide={() => setShowProductDialog(false)}
        onSubmit={handleProductSubmit}
        onCompare={handleCompare}
      />
      <CompareResultModal
        show={showCompareResult}
        onHide={() => setShowCompareResult(false)}
        result={compareResult}
      />
    </Container>
  );
};

export default ColorMatchPage;